module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_type_resort@2x-43aa902e9ce61373955cc5870884c555.webp";